export const analyticsKeys = {
  all: ['analytics'] as const,
  eventList: (params: any) => [...analyticsKeys.all, 'events', params] as const,
  eventSummary: (params: any) => [...analyticsKeys.all, 'events-summary', params] as const,
  growth: (section: string, params: any) => [...analyticsKeys.all, 'growth', section, params] as const,
  geoCities: () => [...analyticsKeys.all, 'geo', 'cities'] as const,
  geoDistricts: (cityId?: number | string | null) => [...analyticsKeys.all, 'geo', 'districts', cityId ?? null] as const,
};
